import { RoleProtected } from '../Components/RoleProtected';
import VehicleListView from '../Components/VehicleConfigPageComp/Views/VehicleListView';

export default function VehicleConfigPage() {
  return (
    <RoleProtected allowedRoles={["Admin", "user"]} showPageAction="vehicle_config_view">
      <VehicleListView />
    </RoleProtected>
  );
}
